<template>
    <div class="seccion">
        <v-container grid-list-xl fluid class="pt-0">
            <v-layout row wrap>
                <v-flex sm4 v-if="campusExpand">
                    <v-card>
                        <v-toolbar color="primary" dark flat>
                            <v-toolbar-title>
                                <v-icon medium>fa-cog</v-icon>
                                Detalles del Campus
                            </v-toolbar-title>
                            <v-divider class="mx-2" inset vertical></v-divider>

                            <v-spacer></v-spacer>
                            <v-toolbar-items>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn icon color="primary" dark @click="campusExpand = false">
                                            <v-icon v-on="on">{{ getCampusSeccionIcon() }}</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Ocultar</span>
                                </v-tooltip>
                            </v-toolbar-items>
                        </v-toolbar>

                        <v-card-text>
                            <v-container fluid grid-list-xl>
                                <v-layout align-center wrap>
                                    <v-flex tag="strong" sm5 text-xs-right mr-2>Código:</v-flex>
                                    <v-flex sm5>{{ campusData.codigo ? campusData.codigo : "-" }}</v-flex>
                                    <v-flex tag="strong" sm5 text-xs-right mr-2>Nombre:</v-flex>
                                    <v-flex sm5>{{ campusData.nombre ? campusData.nombre : "-" }}</v-flex>
                                    <v-flex tag="strong" sm5 text-xs-right mr-2>Estado:</v-flex>
                                    <v-flex sm5>{{
                                        campusData.status_description ? campusData.status_description : "-"
                                    }}</v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-flex>

                <v-flex :class="campusExpand ? 'sm-8' : 'sm12'">
                    <v-card>
                        <v-toolbar color="primary" dark flat>
                            <v-scroll-x-transition>
                                <template v-if="!campusExpand">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn icon color="primary" dark @click="campusExpand = true">
                                                <v-icon v-on="on">{{ getCampusSeccionIcon() }}</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Contraer</span>
                                    </v-tooltip>
                                </template>
                            </v-scroll-x-transition>

                            <v-toolbar-title>
                                <v-icon medium>fa fa-cog</v-icon>
                                Lista de Secciones
                            </v-toolbar-title>

                            <v-divider class="mx-2" inset vertical></v-divider>

                            <v-flex sm3 class="pa-0" style="max-width: 190px">
                                <v-overflow-btn
                                    v-model="seccionEstado"
                                    label="Campus"
                                    :items="[
                                        { text: 'Todas', value: '1' },
                                        { text: 'Habilitadas', value: '2' },
                                        { text: 'Deshabilitadas', value: '3' }
                                    ]"
                                    hide-details
                                    class="pa-0"
                                    @change="loadSeccion()"
                                >
                                    <template v-slot:item="data">
                                        <v-list-tile-content>
                                            <v-card-text class="pa-0 ">
                                                <v-icon
                                                    :color="getIconColor(data)"
                                                    class="pr-3"
                                                    v-if="data.item.value !== '1'"
                                                    >fa-list</v-icon
                                                >
                                                {{ data.item.text }}
                                            </v-card-text>
                                        </v-list-tile-content>
                                    </template>
                                </v-overflow-btn>
                            </v-flex>

                            <v-divider class="px-1" inset vertical></v-divider>

                            <v-spacer></v-spacer>

                            <v-toolbar-items>
                                <v-btn icon @click="toogleSearch()">
                                    <v-icon medium>fa-search</v-icon>
                                </v-btn>

                                <v-expand-x-transition>
                                    <v-text-field
                                        hide-details
                                        solo
                                        v-show="searchShow"
                                        v-model="filter.search"
                                        placeholder="Filtrar"
                                        class="hidden-sm-and-down pt-2"
                                    >
                                    </v-text-field>
                                </v-expand-x-transition>

                                <v-divider class="pa-2"></v-divider>

                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn icon flat @click="openForm(null)">
                                            <v-icon medium v-on="on">fa-plus</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Agregar Seccion</span>
                                </v-tooltip>
                            </v-toolbar-items>
                        </v-toolbar>
                        <v-divider></v-divider>
                        <v-card-text class="pa-0">
                            <v-data-table
                                :headers="headers"
                                :loading="loading"
                                :pagination.sync="pagination"
                                :rows-per-page-items="pagination.rowsPerPageItems"
                                :total-items="totalItems"
                                :items="SECCIONES"
                                class="elevation-1"
                                item-key="id"
                            >
                                <v-progress-linear v-slot:progress color="green" indeterminate></v-progress-linear>
                                <template slot="items" slot-scope="props">
                                    <tr>
                                        <td>{{ props.item.nombre }}</td>
                                        <td>
                                            <v-chip
                                                small
                                                dark
                                                :color="getChipColor(props.item)"
                                                style="font-size: 12px"
                                            >
                                                {{
                                                    props.item.status_description ? props.item.status_description : "-"
                                                }}
                                            </v-chip>
                                            <div class="action-column">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            flat
                                                            icon
                                                            color="orange"
                                                            :disabled="loading || menuLocked"
                                                            @click="openForm(props.item)"
                                                        >
                                                            <v-icon medium v-on="on">fa-edit</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Editar Sección</span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            flat
                                                            icon
                                                            color="red"
                                                            :disabled="loading || menuLocked"
                                                            @click="deleteItem(props)"
                                                        >
                                                            <v-icon medium v-on="on">fa-trash</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Eliminar Sección</span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            flat
                                                            icon
                                                            color="grey"
                                                            :loading="loadingHistory"
                                                            :disabled="loading || menuLocked"
                                                            @click="loadHistory(props.item)"
                                                        >
                                                            <v-icon medium v-on="on">fa-archive</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Ver historial</span>
                                                </v-tooltip>
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                                <template v-slot:expand="props">
                                    <v-card>
                                        <v-card-text class="py-0 pl-0 text-xs-right">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn icon flat color="red" @click="deleteItemCancel(props)">
                                                        <v-icon v-on="on">fa-close</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Cancelar acción</span>
                                            </v-tooltip>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn icon flat color="green" @click="deleteItemConfirm(props)">
                                                        <v-icon v-on="on">fa-check</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Confirmar acción</span>
                                            </v-tooltip>
                                        </v-card-text>
                                    </v-card>
                                </template>
                                <template slot="no-data">
                                    <div style="text-align: center">
                                        No existen secciones registradas en el sistema.
                                    </div>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <seccion-form
            v-if="showForm"
            :form-title="title"
            :initial-item="editItem"
            :campus-id="campusID"
            @formCanceled="closeForm"
        >
        </seccion-form>

        <time-line
            v-if="showHistory"
            :data="historyData"
            :element="'Sección'"
            @formCanceled="showHistory = false"
        ></time-line>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import _ from "lodash"
import Util from "@/util"
const TimeLine = () => import("@/components/widgets/records-time-line/time-line")
const SeccionForm = () => import("@/components/personal/nomencladores/seccion-form/seccion-form")

export default {
    components: { SeccionForm, TimeLine },
    props: {
        campusParam: { type: Number, default: null }
    },
    data: () => ({
        searchShow: false,
        loading: false,
        title: "",
        showForm: false,
        headers: [{ text: "Sección", value: "nombre" }, { text: "Estado", value: "estado" }],
        editItem: null,
        filter: {
            search: ""
        },
        totalItems: 0,

        deleteSeccionConfirmId: "",

        menuLocked: false,

        //estado de las secciones a cargar del back
        seccionEstado: "1",

        //id del campus de donde proviene
        campusID: null,

        //history
        loadingHistory: false,
        showHistory: false,
        historyData: null,

        //seccion del campus
        campusExpand: true,
        campusData: true
    }),

    methods: {
        toogleSearch: function() {
            this.searchShow = !this.searchShow
        },

        loadData(estado) {
            this.loading = true
            this.$store
                .dispatch("LOAD_SECCIONES", {
                    campusID: this.campusID,
                    filter: this.filter.search,
                    seccionEstado: estado
                })
                .then(result => {
                    this.loading = false
                    this.totalItems = result
                })
        },

        openForm(item) {
            if (item !== null) {
                this.title = "Modificar sección"
                this.editItem = item
            } else {
                this.title = "Nueva sección"
            }
            this.showForm = true
        },

        closeForm() {
            this.showForm = false
            this.editItem = null
        },

        deleteItem(props) {
            this.menuLocked = true
            this.deleteSeccionConfirmId = props.item.id
            props.expanded = true
        },

        deleteItemConfirm(props) {
            if (this.deleteSeccionConfirmId === props.item.id) {
                this.loading = true
                this.$store.dispatch("DELETE_SECCION", props.item).then(() => {
                    this.loading = false
                    this.menuLocked = false
                    this.deleteSeccionConfirmId = ""
                    props.expanded = !props.expanded
                })
            }
        },

        deleteItemCancel(props) {
            this.menuLocked = false
            this.deleteSeccionConfirmId = ""
            props.expanded = !props.expanded
        },

        loadSeccion() {
            this.loadData(this.seccionEstado)
        },

        loadHistory(item) {
            this.loadingHistory = true

            let historyClassName = Util.getHistoryClassName("Seccion")
            this.$store.commit("SET_HISTORIALES_TIME_LINE_PAG", { page: 1 })
            this.$store
                .dispatch("LOAD_HISTORIALES_TIME_LINE", { class: historyClassName, class_id: item.id })
                .then(response => {
                    if (response) {
                        this.historyData = this.$store.getters.HISTORIALES_TIME_LINE.historiales
                        this.showHistory = true
                        this.loadingHistory = false
                    } else {
                        this.loadingHistory = false
                    }
                })
        },

        searchData: _.debounce(function() {
            this.loadData(this.seccionEstado)
        }, 1000),

        getChipColor(item) {
            switch (item.estado) {
                case 1:
                    return "success lighten-1"
                case 0:
                    return "grey lighten-1"
            }
        },

        getIconColor(data) {
            switch (data.item.value) {
                case "1":
                    return "black"
                case "2":
                    return "success lighten-1"
                case "3":
                    return "grey lighten-1"
                default:
                    return "black"
            }
        },

        getCampusSeccionIcon() {
            return this.campusExpand ? "fa-angle-left" : "fa-angle-right"
        }
    },

    computed: {
        ...mapGetters(["SECCIONES"]),

        pagination: {
            get: function() {
                return this.$store.getters.SECCIONES_PAG
            },
            set: function(value) {
                this.$store.commit("SET_SECCIONES_PAG", value)
            }
        },
        searchTerm() {
            return this.filter.search
        }
    },

    watch: {
        pagination: {
            handler() {
                this.loadData(this.seccionEstado)
            },
            deep: true
        },
        searchTerm() {
            this.searchData()
        }
    },

    created() {
        if (this.campusParam) {
            localStorage.setItem("campus_id", JSON.stringify(this.campusParam))
        }
    },

    mounted() {
        let campusId = localStorage.getItem("campus_id")
        this.campusID = JSON.parse(campusId)

        this.$store.dispatch("LOAD_CAMPUS_DETAILS_SECCIONES", { id: this.campusID }).then(result => {
            if (result) {
                this.campusData = result
            }
        })
    }
}
</script>

<style scoped></style>
